import React, { useState } from "react";
import { Modal, Typography, Button, Divider, Avatar } from "antd";
import CreateDiary from "assets/images/create-diary.png";
import CreateDiaryModal from "./createDiaryModal";
import User from "models/user/user";
import { GASendEvent } from "features/googleAnalytics/googleAnalytics";
import { downloadEvent } from "utilities/generalUtility";
const { Title } = Typography;

export default function StartDiaryModal({ flag }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = (e) => {
    downloadEvent("createNewJournal");
    setIsModalOpen(true);
  };

  return (
    <>
      <Button
        size="large"
        className="create-journal-btn"
        onClick={showModal}
        ghost={flag ? false : true}
        block
        disabled={!User.isUserctive()}
        type={flag ? "primary" : ""}
      >
        {flag ? "Create Invitation" : "Create New Journal"}
      </Button>
      {isModalOpen && (
        <CreateDiaryModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
}
